import React, {useEffect, useState} from "react";
import DatePicker from "react-datepicker";
import {handleDatePickerKeyDown} from "../../helpers/CalendarEventsRepeater";
import ru from "date-fns/locale/ru";
import {Form, Label} from "semantic-ui-react";
import AppDatePicker from "./AppDatePicker";
import AppTimePicker, {Time} from "./AppTimePicker";
import moment from "moment/moment";
import {SemanticShorthandItem} from "semantic-ui-react/dist/commonjs/generic";
import {LabelProps} from "semantic-ui-react/dist/commonjs/elements/Label";

interface Props {
    value?: Date;
    error?: boolean | SemanticShorthandItem<LabelProps>,
    onChange?: (value?: Date) => void,
    readOnly?: boolean
}

const AppDateTimePicker = (props: Props) => {
    const date = getDatePart(props.value);
    const time = getTimePart(props.value);

    function getDatePart(value?: Date): Date | undefined {
        if (value)
            return moment(value).startOf('day')?.toDate();
        else
            return undefined;
    }

    function getTimePart(value?: Date): Time | undefined {
        if (value)
            return {hour: value.getHours(), minute: value.getMinutes()}
        else
            return undefined;
    }

    const onChanged = (d?: Date, t?: Time) => {
        const nd = d ?? date;
        const nt = t ?? time ?? { hour: 0, minute: 0};
        if (nd && nt) {
            const nv = moment(nd).add((nt!.hour * 60 + nt!.minute), "minutes").toDate();
            if (props.onChange)
                props.onChange!(nv);
        }
    };

    return (<Form.Group style={{margin: "0px"}}>
        <Form.Field error={props.error}>
            <AppDatePicker value={date} onChange={(v) => onChanged(v, undefined) } readOnly={props.readOnly}/>
        </Form.Field>
        <Form.Field error={!!props.error}>
            <AppTimePicker value={time} onChange={(v) => onChanged(undefined, v) } readOnly={props.readOnly}/>
        </Form.Field>
        {props.error && <Label basic color='red' pointing='left'>{props.error}</Label>}
    </Form.Group>);
}

export default AppDateTimePicker;